"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _defineProperty2 = require("babel-runtime/helpers/defineProperty");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _stringify = require("babel-runtime/core-js/json/stringify");

var _stringify2 = _interopRequireDefault(_stringify);

var _promise = require("babel-runtime/core-js/promise");

var _promise2 = _interopRequireDefault(_promise);

var _slicedToArray2 = require("babel-runtime/helpers/slicedToArray");

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _jquery = require("jquery");

var _jquery2 = _interopRequireDefault(_jquery);

var _constants = require("./constants");

var _rpAnalytics = require("rp-analytics");

var SegmentIO = _interopRequireWildcard(_rpAnalytics);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BookmakersTierOne = function () {
	function BookmakersTierOne(selector) {
		(0, _classCallCheck3.default)(this, BookmakersTierOne);

		this.$selector = (0, _jquery2.default)(selector);
		this.$isMobile = $(window).width() < 768;
		this.localStorageChange = false;
		this.getLastClickedOnBetsCTAName = "lastClickedOnBetsCTA" + (this.$isMobile ? "Mobile" : "Desktop");
		this.lastClickedOnBetsCTA = JSON.parse(localStorage.getItem(this.getLastClickedOnBetsCTAName));
		this.$freeBetsNotifications = this.$selector.find(_constants.selectors.freeBetsNotifications);
		this.$freeBetsNotificationsNumber = this.$freeBetsNotifications.find(_constants.selectors.freeBetsNotificationsNumber);

		this.init();
	}

	(0, _createClass3.default)(BookmakersTierOne, [{
		key: "init",
		value: function init() {
			this.fetchDataFromAPI();
		}

		/**
   * Check if the date is in the valid format
   *
   * @param {String} datetimeString
   * @returns boolean
   */

	}, {
		key: "isValidDateFormat",
		value: function isValidDateFormat(datetimeString) {
			// Regular expression to check the format YYYY-MM-DDTHH:mm±HH:mm
			var regex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}([+-]\d{2}:\d{2})?$/;

			var isValidDateTime = regex.test(datetimeString);

			if (!isValidDateTime) {
				return false;
			}

			var date = new Date(datetimeString).getTime();

			return !isNaN(date);
		}

		/**
   * Convert date in UTC format
   *
   * @param {String} datetimeString
   * @param {Boolean} isCurerentDateTime
   * @returns string
   */

	}, {
		key: "formatDateToUKTime",
		value: function formatDateToUKTime(datetimeString) {
			var isCurerentDateTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

			var date = isCurerentDateTime ? new Date() : new Date(datetimeString);

			var options = {
				year: "numeric",
				month: "2-digit",
				day: "2-digit",
				hour: "2-digit",
				minute: "2-digit",
				hour12: false,
				timeZone: "UTC"
			};

			var formattedDate = new Intl.DateTimeFormat("en-GB", options).format(date);

			var _formattedDate$split = formattedDate.split(/[/,\s:]+/),
			    _formattedDate$split2 = (0, _slicedToArray3.default)(_formattedDate$split, 5),
			    day = _formattedDate$split2[0],
			    month = _formattedDate$split2[1],
			    year = _formattedDate$split2[2],
			    hour = _formattedDate$split2[3],
			    minute = _formattedDate$split2[4];

			return year + "-" + month + "-" + day + "T" + hour + ":" + minute + "+00:00";
		}

		/**
   * Handle visibility of the badge based on the last clicked date
   *
   */

	}, {
		key: "handleBadgeVisibility",
		value: function handleBadgeVisibility() {
			var isClicked = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

			this.lastClickedOnBetsCTA = JSON.parse(localStorage.getItem(this.getLastClickedOnBetsCTAName));

			if (!this.getNumberOfOffers) {
				this.$freeBetsNotifications.attr(_constants.attributes.dataVisible, "false");

				return;
			}

			if (!this.lastClickedOnBetsCTA || this.isUpdatedAfterLastClick() && !isClicked) {
				this.$freeBetsNotificationsNumber.text(this.getNumberOfOffers);
				this.$freeBetsNotifications.attr(_constants.attributes.dataVisible, "true");
			} else {
				this.$freeBetsNotifications.attr(_constants.attributes.dataVisible, "false");
			}
		}

		/**
   * Call the bookmakers tier one API and render the component with the data
   * For local testing -> await fetch(`http://dev-beta.racingpost.com:8080/api/stubs/bookmaker-offers-tier-one/`)
   *
   */

	}, {
		key: "fetchDataFromAPI",
		value: function fetchDataFromAPI() {
			var that = this;

			new _promise2.default(function (resolve, reject) {
				_jquery2.default.ajax({
					url: window.location.origin + "/api/stubs/bookmaker-offers-tier-one/"
				}).done(function (data) {
					that.freeBetsDesktopOffers = data.freeBetsDesktopOffers;
					that.freeBetsMobileOffers = data.freeBetsMobileOffers;

					that.freeBetsMobileOffers = {
						linkUrl: that.freeBetsMobileOffers.linkUrl,
						numberOfOffers: that.freeBetsMobileOffers.numberOfOffers,
						datetimeUpdated: that.isValidDateFormat(that.freeBetsMobileOffers.datetimeUpdated) ? that.formatDateToUKTime(that.freeBetsMobileOffers.datetimeUpdated) : null
					};
					that.freeBetsDesktopOffers = {
						linkUrl: that.freeBetsDesktopOffers.linkUrl,
						numberOfOffers: that.freeBetsDesktopOffers.numberOfOffers,
						datetimeUpdated: that.isValidDateFormat(that.freeBetsDesktopOffers.datetimeUpdated) ? that.formatDateToUKTime(that.freeBetsDesktopOffers.datetimeUpdated) : null
					};

					that.datetimeUpdated = that.$isMobile ? that.freeBetsMobileOffers.datetimeUpdated : that.freeBetsDesktopOffers.datetimeUpdated;

					that.getNumberOfOffers = that.$isMobile ? that.freeBetsMobileOffers.numberOfOffers : that.freeBetsDesktopOffers.numberOfOffers;

					that.handleBadgeVisibility();
					that.handleClick();

					resolve();
				}).fail(function () {
					reject("Can't resolve all necessary information from secure server!");
				});
			});
		}

		/**
   * Update the notification count objects in case when we click on the free bets link
   * to hide the notification badge
   *
   */

	}, {
		key: "updateNotificationCount",
		value: function updateNotificationCount() {
			var modifiedOffers = this.$isMobile ? {
				numberOfOffers: !this.lastClickedOnBetsCTA ? this.freeBetsMobileOffers.numberOfOffers : null,
				datetimeUpdated: this.formatDateToUKTime(new Date(), true)
			} : {
				numberOfOffers: !this.lastClickedOnBetsCTA ? this.freeBetsDesktopOffers.numberOfOffers : null,
				datetimeUpdated: this.formatDateToUKTime(new Date(), true)
			};

			localStorage.setItem(this.getLastClickedOnBetsCTAName, (0, _stringify2.default)(modifiedOffers));
		}

		/**
   * Compare the dates between the last clicked date and the date when the data was updated
   *
   */

	}, {
		key: "isUpdatedAfterLastClick",
		value: function isUpdatedAfterLastClick() {
			if (!this.lastClickedOnBetsCTA) return false;

			var lastClickedDate = new Date(this.lastClickedOnBetsCTA.datetimeUpdated).getTime();

			var updatedDate = new Date(this.datetimeUpdated).getTime();

			return updatedDate > lastClickedDate;
		}

		/**
   * Handle the click event on the free bets link, update the notification count
   * and trigger the trackFreeBetsTap event
   *
   */

	}, {
		key: "handleClick",
		value: function handleClick() {
			var that = this;

			this.$selector.on("click", function () {
				if (!that.lastClickedOnBetsCTA || that.isUpdatedAfterLastClick()) {
					that.localStorageChange = !that.localStorageChange;

					that.$freeBetsNotificationsNumber.text(!that.localStorageChange ? that.getNumberOfOffers : null);
				}

				var modifiedOffers = {
					datetimeUpdated: that.formatDateToUKTime(new Date(), true),
					numberOfOffers: null
				};

				localStorage.setItem(that.getLastClickedOnBetsCTAName, (0, _stringify2.default)(modifiedOffers));

				that.handleBadgeVisibility(true);
				that.updateNotificationCount();

				SegmentIO.trackFreeBetsTap((0, _defineProperty3.default)({}, SegmentIO.TRAIT_NUMBER_OF_OFFERS, that.getNumberOfOffers ? that.getNumberOfOffers : null), true);
			});
		}
	}]);
	return BookmakersTierOne;
}();

exports.default = BookmakersTierOne;


//////////////////
// WEBPACK FOOTER
// ./~/rp-navigation/lib/bookmakersTierOne/BookmakersTierOne.js
// module id = 2673
// module chunks = 1